import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-primary-400 whitespace-nowrap">
              韩漫阅读
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              专注耽美题材无删减韩国漫画，下拉式免费在线阅读平台。持续更新优质耽美韩漫，满足您对特定题材的阅读偏好。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@hanman.life</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>韩国首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 韩漫阅读. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}